import { render, staticRenderFns } from "./FestivalView.vue?vue&type=template&id=5c0099fe&"
import script from "./FestivalView.vue?vue&type=script&lang=ts&"
export * from "./FestivalView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports